import {
  messages as updateStoresMessages,
  barcodeContent as updateStoresBarcode,
  hotkey as updateStoresHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/update-stores';
import {
  messages as createOrderMessages,
  barcodeContent as createOrderBarcode,
  hotkey as createOrderHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/create-new-order';
import {
  messages as viewOrderDetailsMessages,
  barcodeContent as viewOrderDetailsBarcode,
  hotkey as viewOrderDetailsHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/view-order-details';
import {
  messages as readWeightFromScaleMessages,
  barcodeContent as readWeightFromScaleBarcode,
  hotkey as readWeightFromScaleHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/read-weight-from-scale';
import {
  messages as getRateMessages,
  barcodeContent as getRateBarcode,
  hotkey as getRateHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/get-rate';
import {
  messages as createLabelMessages,
  barcodeContent as createLabelBarcode,
  hotkey as createLabelHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/create-label';
import {
  messages as showRateCalcMessages,
  barcodeContent as showRateCalcBarcode,
  hotkey as showRateCalcHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/open-rate-calc';
import {
  messages as createBatchMessages,
  barcodeContent as createBatchBarcode,
  hotkey as createBatchHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/create-new-batch';
import {
  messages as toggleQuickshipMessages,
  barcodeContent as toggleQuickshipBarcode,
  hotkey as toggleQuickShipHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/toggle-quickship';
import {
  messages as reloadOrdersGridMessages,
  barcodeContent as reloadOrdersGridBarcode,
  hotkey as reloadOrdersGridHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/reload-orders-grid';
import {
  messages as processBatchMessages,
  barcodeContent as processBatchBarcode,
  hotkey as processBatchHotkey,
} from '../../../../../../../components/hotkeys/advanced-hotkeys/process-batch';

export default [
  {
    barcodeContent: updateStoresBarcode,
    intlFormattedName: updateStoresMessages.name,
    hotkey: updateStoresHotkey,
  },
  {
    barcodeContent: createOrderBarcode,
    intlFormattedName: createOrderMessages.name,
    hotkey: createOrderHotkey,
  },
  {
    barcodeContent: viewOrderDetailsBarcode,
    intlFormattedName: viewOrderDetailsMessages.name,
    hotkey: viewOrderDetailsHotkey,
  },
  {
    barcodeContent: readWeightFromScaleBarcode,
    intlFormattedName: readWeightFromScaleMessages.name,
    hotkey: readWeightFromScaleHotkey,
  },
  {
    barcodeContent: getRateBarcode,
    intlFormattedName: getRateMessages.name,
    hotkey: getRateHotkey,
  },
  {
    barcodeContent: createLabelBarcode,
    intlFormattedName: createLabelMessages.name,
    hotkey: createLabelHotkey,
  },
  {
    barcodeContent: showRateCalcBarcode,
    intlFormattedName: showRateCalcMessages.name,
    hotkey: showRateCalcHotkey,
  },
  {
    barcodeContent: createBatchBarcode,
    intlFormattedName: createBatchMessages.name,
    hotkey: createBatchHotkey,
  },
  {
    barcodeContent: toggleQuickshipBarcode,
    intlFormattedName: toggleQuickshipMessages.name,
    hotkey: toggleQuickShipHotkey,
  },
  {
    barcodeContent: reloadOrdersGridBarcode,
    intlFormattedName: reloadOrdersGridMessages.name,
    hotkey: reloadOrdersGridHotkey,
  },
  {
    barcodeContent: processBatchBarcode,
    intlFormattedName: processBatchMessages.name,
    hotkey: processBatchHotkey,
  },
];
